import { z } from 'zod';

export const FavoriteObjectType = z.enum(['store']);

export type FavoriteObjectType = z.infer<typeof FavoriteObjectType>;
